module.exports = __webpack_public_path__ + "img/AC_S1_Header.895cbe5a.jpg";